const stats = [
  { number: "20+", label: "Years in Acquisitions" },
  { number: "3", label: "Continents Active" },
  { number: "12+", label: "Sectors of Expertise" },
  { number: "100%", label: "Confidential Process" },
];

const pillars = [
  { num: "01", title: "DEAL ORIGINATION", desc: "Proprietary, off-market UK businesses we identify, acquire, and build — not sourced for others." },
  { num: "02", title: "CROSS-BORDER CAPITAL", desc: "MENA-focused capital connected to strategically aligned UK opportunities." },
  { num: "03", title: "EXECUTION", desc: "Transactions enabled with precision, discretion, and cross-jurisdictional alignment." },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#0d0d0d] py-20 sm:py-28 px-5 sm:px-8 md:px-16">
      {/* Top tagline */}
      <div className="text-center mb-14 sm:mb-20">
        <h2 className="text-white font-serif text-2xl sm:text-3xl md:text-5xl tracking-wide mb-4">
          FOCUSED. SELECTIVE. GLOBAL.
        </h2>
        <p className="text-[#c9a84c] text-[10px] sm:text-xs tracking-[3px] sm:tracking-[5px] uppercase">
          Partners in value creation across markets
        </p>
      </div>

      {/* Three pillars */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-0 max-w-6xl mx-auto mb-20 sm:mb-28 border border-white/10 sm:border-0">
        {pillars.map((p, i) => (
          <div
            key={p.num}
            className={`py-8 sm:py-10 px-6 sm:px-8 border-b sm:border-b-0 border-white/10 last:border-b-0 ${
              i < 2 ? "sm:border-r sm:border-white/10" : ""
            } sm:border-t-0`}
          >
            <p className="text-[#c9a84c] text-2xl sm:text-3xl font-serif mb-3 sm:mb-4">{p.num}</p>
            <h3 className="text-white text-xs sm:text-sm tracking-[2px] sm:tracking-[3px] font-medium mb-3 sm:mb-4">{p.title}</h3>
            <p className="text-white/50 text-sm leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>

      {/* Approach block */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-0 border border-white/10">
        {/* Left image */}
        <div className="relative h-[220px] sm:h-[320px] lg:h-auto overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/32506285361243502f9b1d791338447f.jpg"
            alt="Our approach"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0d0d0d]/60" />
        </div>

        {/* Right content */}
        <div className="p-6 sm:p-10 md:p-16 flex flex-col justify-center">
          <p className="text-[#c9a84c] text-[10px] sm:text-xs tracking-[3px] sm:tracking-[5px] uppercase mb-4 sm:mb-6">Our Approach</p>
          <h2 className="text-white font-serif text-2xl sm:text-4xl md:text-5xl leading-tight mb-5 sm:mb-8">
            DISCIPLINE.<br />EXPERIENCE.<br />RESULTS.
          </h2>
          <p className="text-white/55 text-sm leading-relaxed mb-6 sm:mb-10">
            88ELEVEN Capital is a private platform focused on originating and structuring strategic acquisition opportunities across the UK and international markets.
            <br /><br />
            We acquire and build our own projects — we do not source deals for third parties. Every opportunity we pursue is one we are directly invested in, ensuring full alignment of interest from origination through to execution.
            <br /><br />
            We partner with a select group of international capital — particularly across the MENA region — to participate alongside us in carefully chosen UK acquisitions.
          </p>
          <div className="border-t border-white/10 pt-5 sm:pt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
            {["UK–MENA CONNECTIVITY", "SECTOR EXPERTISE", "STRICT CONFIDENTIALITY"].map((item) => (
              <div key={item}>
                <p className="text-white text-[10px] sm:text-xs tracking-[2px] leading-relaxed">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-6xl mx-auto mt-16 sm:mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
        {stats.map((s) => (
          <div key={s.label} className="bg-[#0d0d0d] py-8 sm:py-10 px-4 sm:px-8 text-center">
            <p className="text-[#c9a84c] font-serif text-3xl sm:text-4xl md:text-5xl mb-2 sm:mb-3">{s.number}</p>
            <p className="text-white/40 text-[10px] sm:text-xs tracking-[1px] sm:tracking-[2px] uppercase">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
